import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { selectDraftBoardForm } from "../Settings/redux/selector";
import { useBoardFormChanged } from "../Settings/helper";
import { useBoardsActions } from "../useBoardsActions";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { DragData } from "../../containers/Tickets/types";
import { useDragFieldSync } from "./Usedragfieldsync";

export function useDispatchMove() {
  const dispatch = useDispatch();
  const {
    groupBy,
    subGroupBy,
    _id: boardId,
  } = useSelector(selectDraftBoardForm);
  const { project } = useParams();
  const isFormChanged = useBoardFormChanged();
  const { updateBoardsGroupsJson } = useBoardsActions(project as string);
  const syncFields = useDragFieldSync();

  return (
    data: DragData,
    targetGroupId: string,
    targetSubGroupId: string | null,
    destinationIndex: number,
    skipIfSame?: { ticketId: string },
  ) => {
    if (skipIfSame && !data.isMulti && data.ticketId === skipIfSame.ticketId)
      return;
    const ticketIds = data.isMulti ? data.selectedTicketIds : [data.ticketId];

    // ── 1. Redux local update ─────────────────────────────────────────────
    if (data.isMulti) {
      dispatch(
        ticketGroupsActions.moveMultipleTickets({
          ticketIds,
          sourceGroupId: data.status,
          targetGroupId,
          sourceSubGroupId: data.subGroupId,
          targetSubGroupId,
          destinationIndex,
          groupBy,
          subGroupBy: subGroupBy ?? null,
        }),
      );
    } else {
      dispatch(
        ticketGroupsActions.moveTicket({
          ticketId: data.ticketId,
          sourceGroupId: data.status,
          targetGroupId,
          sourceSubGroupId: data.subGroupId,
          targetSubGroupId,
          sourceIndex: data.index,
          destinationIndex,
          groupBy,
          subGroupBy: subGroupBy ?? null,
        }),
      );
    }

    // ── 2. API field sync ─────────────────────────────────────────────────
    syncFields({
      groupBy,
      subGroupBy,
      sourceGroupId: data.status,
      targetGroupId,
      sourceSubGroupId: data.subGroupId,
      targetSubGroupId,
      ticketIds,
    });

    // ── 3. Board JSON sync ────────────────────────────────────────────────
    if (!isFormChanged) {
      updateBoardsGroupsJson(boardId);
    }
  };
}
